import React from "react";
import {
  FaDatabase,
  FaSpinner,
} from "react-icons/fa";

function StatusBadge({ status }) {
  const normalizedStatus = String(status || "").toLowerCase();
  const isOnline = normalizedStatus === "online" || normalizedStatus === "active" || normalizedStatus === "a";
  const isCreating = normalizedStatus === "creating";
  const isError = normalizedStatus === "error";

  let label = "Offline";

  if (isOnline) {
    label = "Active";
  } else if (isCreating) {
    label = "Creating...";
  } else if (isError) {
    label = "Error";
  }

  return (
    <span
      className={`badge rounded-pill ${
        isOnline 
          ? "text-bg-success"
          : isCreating
          ? "text-bg-warning"
          : isError
          ? "text-bg-danger"
          : "text-bg-secondary"
      }`}
    >
      <span
        className="d-inline-block rounded-circle me-1"
        style={{width: 6, height: 6, background: "currentColor",}}
      />

      {label}
    </span>
  );
}

function formatDate(value) {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString();
}

export default function DomainTable({
  domains = [],
  loading,
}) {

  return (
    <div className="card shadow-sm border-0">
      <div className="table-responsive">
        <table className="table  table-bordered table-hover align-middle mb-0" style={{ color: "#222" }}>
          <thead className="table-light">
            <tr>
              <th className="width-4p">ID</th>
              <th>Domain</th>
              <th>API Key</th>
              <th>Database Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Created</th>
              <th>Last Modified</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td
                  colSpan={7}
                  className="text-center py-5 text-muted fs-5"
                >
                  <FaSpinner size={40} className="spin me-2" />

                  Loading databases...
                </td>
              </tr>
            )}

            {/* ---------------------------------------------------------
                Empty
            ---------------------------------------------------------- */}
            {!loading &&
              domains.length === 0 && (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-5 text-muted"
                  >
                    No databases found.
                  </td>
                </tr>
              )}

            {/* ---------------------------------------------------------
                Data
            ---------------------------------------------------------- */}
            {!loading &&
              domains.map((db) => (
                <tr key={db.id}>

                  {/* ID */}
                  <td className="text-muted small">
                    {db.id}
                  </td>
                  <td className="">
                    {db.domain}
                  </td>
                  <td className="">
                    {db.api_key}
                  </td>

                  {/* Database Name */}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaDatabase className="text-secondary" />

                      <span className="fw-semibold">
                        {db.name || "-"}
                      </span>
                    </div>
                  </td>

                  {/* Type */}
                  <td>
                    <span className="badge fs-6 text-bg-light border border-primary rounded-pill py-2 px-4">
                      {db.type || "-"}
                    </span>
                  </td>

                  {/* Status */}
                  <td>
                    <StatusBadge
                      status={db.status}
                    />
                  </td>

                  {/* Created */}
                  <td className="text-muted small">
                    {formatDate(db.createdat)}
                  </td>

                  {/* Last Modified */}
                  <td className="text-muted small">
                    {formatDate(db.lastmodified)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .spin {
          animation: dp-spin 0.9s linear infinite;
        }

        @keyframes dp-spin {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }

        .table-col-bordered > thead > tr > th,
        .table-col-bordered > tbody > tr > td {
          border-right: 1px solid #dee2e6;
        }

        .table-col-bordered > thead > tr > th:last-child,
        .table-col-bordered > tbody > tr > td:last-child {
          border-right: none;
        }

        .table-col-bordered > thead > tr > th {
          border-bottom: 2px solid #dee2e6;
        }
      `}</style>
    </div>
  );
}